





















import { Vue, Component, Prop } from "vue-property-decorator";
import { UserProfile } from "@api/models/UserProfile";
import UserIcon from '../../common/UserIcon.vue';

@Component({
    components: { UserIcon }
})
export default class Speaker extends Vue {
    @Prop({default: null}) speaker: UserProfile|null;
    @Prop() speakersAmount: number;
    @Prop({default: false}) alwaysFull: boolean; //always show full name part
    @Prop({default: false}) alwaysShort: boolean; //always show only image
    @Prop({default: false}) useJob: boolean;
    @Prop({default: 32}) userIconSize: number;

    @Prop({default: false}) isMore: boolean;
    @Prop({default: null}) amount: number|null;


    get fullName(): string {
        return (this.speaker?.fullName as string);
    }

    get company(): string {
        return this.speaker?.company || '';
    }

    get firstEntranceStatus() {
        if (this.speaker) {
            return this.speaker.firstEntranceStatus ||  false;
        }
        return false;
    }

    get job() {
        return this.speaker?.job;
    }

    get backend() {
        return this.$store.state.session.backend;
    }

    get sizeClass(): string {
        if (this.alwaysShort === true) {
            return 'is-medium';
        }
        if (this.speakersAmount <= 2 || this.alwaysFull) {
            return 'is-normal';
        }
        return 'is-medium';
    }
}
